import * as modalStack from './modalStack';

type ViewHandler = (state: unknown) => void;

let viewHandler: ViewHandler | null = null;
let initialized = false;

function handlePopState(event: PopStateEvent): void {
  const topEntry = modalStack.peek();
  if (topEntry) {
    if (topEntry.canDismiss()) {
      modalStack.pop();
      topEntry.onClose();
    } else {
      // Close is disabled right now (e.g. a pending async operation) — undo
      // the browser's back navigation by re-pushing a modal-typed entry for
      // the still-open modal, so it stays the back-stack target once
      // closing is re-enabled. `event.state` is the *destination* entry the
      // browser already landed on (the view/entry below this modal, not the
      // modal itself) — re-pushing it verbatim would desync the entry's
      // content from what modalStack still considers open.
      window.history.pushState({ navType: 'modal', modalId: topEntry.id }, '');
    }
    return;
  }

  if (viewHandler) {
    viewHandler(event.state);
  }
}

export function registerViewHandler(fn: ViewHandler): void {
  viewHandler = fn;
}

export function unregisterViewHandler(fn: ViewHandler): void {
  if (viewHandler === fn) {
    viewHandler = null;
  }
}

export function initPopstateDispatcher(): void {
  if (initialized) {
    return;
  }
  initialized = true;
  window.addEventListener('popstate', handlePopState);
}
